import React, { useRef, useEffect } from 'react';
import { getProductImage } from '../utils/imageHelper.js';
import { useNavigate, Link } from 'react-router';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import { slugify } from '../utils/slugify';
import { useSession } from '../Cart-Context/session.js'; 
import { trackEvent } from '../utils/trackEvents'; 
import '../App.css';

const STORE_NAME = "Market";

const Home = ({ featuredProducts }) => {
  const { sessionId, experimentId } = useSession(); 
  const navigate = useNavigate();
  const scrollRef = useRef(null); 

  // Track when the user arrives at the Home page
  useEffect(() => {
    trackEvent(sessionId, 'PAGE_VIEW', 'Home Page', {}, experimentId);
  }, [sessionId, experimentId]);

  const scroll = (direction) => {
    const { current } = scrollRef;
    if (current) {
      trackEvent(sessionId, 'CLICK', 'Carousel Arrow', { direction: direction }, experimentId);
      const scrollAmount = 300; 
      current.scrollBy({ 
        left: direction === 'left' ? -scrollAmount : scrollAmount, 
        behavior: 'smooth' 
      });
    }
  };

  return (
    <div>
      <section className="welcome-section">
        <h1 className="welcome-title">Welcome to {STORE_NAME}</h1>
        <button 
          className="shop-now-btn" 
          onClick={() => {
            sessionStorage.removeItem('lastProductsPage');
            trackEvent(sessionId, 'CLICK', 'Shop Now Button', {}, experimentId);
            navigate("/products");
          }}
        >
          Shop Now
        </button>
      </section>

      <section className="content-section carousel-section">
        <h2>Featured Products</h2>
        
        {featuredProducts && featuredProducts.length > 0 ? (
          <div className="carousel-container">
            <button className="carousel-arrow left" onClick={() => scroll('left')}>
              <FaChevronLeft />
            </button>

            <div className="carousel-track" ref={scrollRef}>
              {featuredProducts.map((product) => (
                <Link
                  key={product.id} 
                  className="featured-card"
                  to={`/product/${product.id}/${slugify(product.name)}`}
                  state={{ from: "/" }}
                  onClick={() => trackEvent(sessionId, 'CLICK', 'Featured Product Link', { 
                    productName: product.name,
                    price: product.price 
                  }, experimentId)}
                >
                  <div className="carousel-image-wrapper">
                    {product.image ? (
                      <img src={getProductImage(product.image)} alt={product.name} />
                    ) : (
                      <div className="no-image">No Image</div>
                    )}
                  </div>
                  <h4>{product.name}</h4>
                  <p>${Number(product.price?.toString().replace('$', '')).toFixed(2)}</p>
                </Link>
              ))}
            </div>

            <button className="carousel-arrow right" onClick={() => scroll('right')}>
              <FaChevronRight />
            </button>
          </div>
        ) : (
          <p className="placeholder-text">Loading featured items...</p>
        )}
      </section>

      <section className="content-section">
        <h2>Our Mission:</h2>
        <p className="mission-text">
          At Market, our mission is to use this technology to help you make more healthy shopping decisions. 
          Our goal is to create an online retail environment that helps you discover and choose foods that support a healthier lifestyle.
        </p>
      </section>
    </div>
  );
};

export default Home;